module.exports = __webpack_public_path__ + "static/media/giphy-3.919a105d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-3.gif
// module id = 174
// module chunks = 0